import { useMemo, useState } from 'react';
import {
  Box,
  Button,
  Divider,
  IconButton,
  Paper,
  Typography,
} from '@mui/material';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import { useLocation, useNavigate } from 'react-router';
import { useAppContext } from '../../contexts/AppContext';
import { defaultAddresses } from './checkoutData';
import '../Customer/CustomerScreens.scss';

export default function Checkout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAppContext();
  const savedAddresses = useMemo(() => {
    const newAddress = location.state?.newAddress;
    return newAddress ? [newAddress, ...defaultAddresses] : defaultAddresses;
  }, [location.state]);

  const initialAddressId =
    location.state?.selectedAddressId || savedAddresses[0]?.id || '';
  const [selectedAddressId, setSelectedAddressId] = useState(initialAddressId);

  const selectedAddress =
    savedAddresses.find((item) => item.id === selectedAddressId) || savedAddresses[0];

  return (
    <Box className='customer-screen'>
      <Box className='customer-shell'>
        <Box className='customer-topbar'>
          <IconButton className='customer-iconButton' onClick={() => navigate(-1)}>
            <ArrowBackRoundedIcon />
          </IconButton>
          <Typography className='customer-topbarTitle'>Shipping Address</Typography>
          <Box sx={{ width: 46 }} />
        </Box>

        <Paper className='customer-card' sx={{ p: 2 }}>
          <Box className='checkout-optionList'>
            {savedAddresses.map((item, index) => {
              const isActive = item.id === selectedAddressId;

              return (
                <Box key={item.id}>
                  <Box
                    className='checkout-optionRow'
                    component='button'
                    onClick={() => setSelectedAddressId(item.id)}
                    sx={{ border: 0, width: '100%', background: 'transparent', cursor: 'pointer' }}
                  >
                    <Box className='checkout-optionMain'>
                      <Box className='customer-menuIcon'>
                        <PlaceOutlinedIcon fontSize='small' />
                      </Box>
                      <Box sx={{ textAlign: 'left' }}>
                        <Typography sx={{ fontWeight: 700 }}>{item.label}</Typography>
                        <Typography className='customer-muted'>{item.address}</Typography>
                      </Box>
                    </Box>
                    <Box
                      className={`checkout-radio${isActive ? ' checkout-radio--active' : ''}`}
                    />
                  </Box>
                  {index < savedAddresses.length - 1 ? <Divider /> : null}
                </Box>
              );
            })}
          </Box>
        </Paper>

        <Button
          className='checkout-addButton'
          startIcon={<AddRoundedIcon />}
          sx={{ width: '100%', mt: 2 }}
          onClick={() => navigate('/checkout/address/new', { state: { from: '/checkout' } })}
        >
          Add New Shipping Address
        </Button>

        <Paper className='checkout-stickyFooter'>
          <Button
            className='customer-actionButton customer-actionButton--primary'
            fullWidth
            onClick={() =>
              navigate('/checkout/shipping', {
                state: {
                  address: selectedAddress,
                  selectedAddressId,
                  userName: user?.name || 'Guest User',
                },
              })
            }
          >
            Apply
          </Button>
        </Paper>
      </Box>
    </Box>
  );
}
